import { render, staticRenderFns } from "./BatchManage.vue?vue&type=template&id=6b473274&scoped=true&"
import script from "./BatchManage.vue?vue&type=script&lang=ts&"
export * from "./BatchManage.vue?vue&type=script&lang=ts&"
import style0 from "./BatchManage.vue?vue&type=style&index=0&id=6b473274&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b473274",
  null
  
)

export default component.exports